import React, { useEffect, useState } from "react";
import { IoClose, IoMenu } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { setIsOpenRightMenu } from "../../store/reducers/menuReducer";

const RightMenu = ({ children }) => {

    const dispatch = useDispatch();
    const { isOpenRightMenu } = useSelector(state => state.menu);
    const { user } = useSelector(state => state.user);
    const location = useLocation();

    useEffect(() => {
        if (isOpenRightMenu) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpenRightMenu]);

    return (
        <div className="right-menu d-block d-lg-none">
            {
                !isOpenRightMenu ?
                    <div className="d-flex justify-content-end pt-2 pe-2">
                        <div className="menu-icon" onClick={() => dispatch(setIsOpenRightMenu(true))}>
                            <IoMenu className="text-white" />
                        </div>
                    </div>
                    : null
            }
            <div className={`layer ${isOpenRightMenu ? 'visible' : ''}`} onClick={() => dispatch(setIsOpenRightMenu(false))}></div>
            <div className={`right-menu-item ${isOpenRightMenu ? 'open' : ''}`}>
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <IoClose className="text-white close-icon" size={30} onClick={() => dispatch(setIsOpenRightMenu(false))} />
                        <div>
                            <strong className="title">CТУДИЯ РАЗВИТИЯ ДЕТСКОЙ РЕЧИ</strong>
                            <br />
                            <em className="sub-title"><i>Натальи Смагиной</i></em>
                        </div>
                        <div className="mt-4">
                            {children}
                        </div>
                    </div>
                    <div>
                        <div className="description">
                            <p className="mb-1">Студия Развития Детской Речи Натальи Смагиной.</p>
                            <strong>@{new Date().getFullYear()}</strong>
                            <br />
                            <p>Все права защищены</p>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Link className="button radius-50" to="/" onClick={() => dispatch(setIsOpenRightMenu(false))}>
                                на главную
                            </Link>
                        </div>
                        {
                            location.pathname === "/account" ? null :
                                user ? <div className="d-flex justify-content-center">
                                    <Link className="button radius-50 mt-2 text-nowrap" to="/account" onClick={() => dispatch(setIsOpenRightMenu(false))}>
                                        личный кабинет
                                    </Link>
                                </div> :
                                    <div className="d-flex justify-content-center">
                                        <Link className="button radius-50 mt-2" to="/login" onClick={() => dispatch(setIsOpenRightMenu(false))}>
                                            войти
                                        </Link>
                                    </div>
                        }
                        {
                            user ?
                                <div className="d-flex justify-content-center">
                                    <Link className="button radius-50 mt-2" to="/logout" onClick={() => dispatch(setIsOpenRightMenu(false))}>
                                        выйти
                                    </Link>
                                </div>
                                : null
                        }


                    </div>
                </div>
            </div>
        </div>
    );
};

export default RightMenu;
